module.exports = __webpack_public_path__ + "travel.a6e8b3b10264cd161e88.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/travel/webfont/travel.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/travel/webfont/travel.woff
// module chunks = styles